module.exports = __webpack_public_path__ + "img/Group 1232.82904d57.svg";